
    import React from "react";
    import {  useSelector } from "react-redux";
   
    
    
    const AuthorInfo = ({ authInfo}) => {
     
    console.log("authinfo exists",authInfo)
    
      if (!authInfo) {
        return <p className="text-gray-600">Loading author info...</p>;
      }

      const { authorName, image_url } = authInfo
 
      return (
        <div className=" flex flex-col items-center justify-center">
          {/* <div >author info rendering</div>
              <div>Author: {authorName}</div> */}

          <img src={image_url} alt={authorName} className="w-40 h-40 rounded-full" />
          <p className="text-lg font-semibold text-gray-800 ">{authorName}  </p>
        </div>
      );
    };



    
    export default AuthorInfo;
    
